import { CollateralInfo } from "../../Trove/PSY/CollateralInfo";
import { SingleValue } from "../../PSY/SingleValue";
import { COIN } from "src/strings";
import { Link } from "react-router-dom";
import { Button } from "src/components/PSY/Button"
import { Decimal, StabilityDeposit } from "@liquity/lib-base"
import { CollateralLexicon } from "src/lexicon"

type Props = {
  lexicon: CollateralLexicon
  stabilityDeposit: StabilityDeposit;
  slsdInStabilityPool: Decimal;
  spAddress: string
}
export const StabilityPoolListRow: React.FC<Props> = ({ lexicon, spAddress, stabilityDeposit, slsdInStabilityPool }) => {

  return (
    <div className="flex flex-row justify-between items-center bg-component border-component p-5 w-full">
      <CollateralInfo
        name={lexicon.name}
        iconUrl={lexicon.iconUrl}
        unit={lexicon.term}
        className="min-w-[240px]"
      />
      <SingleValue
        label="Total Deposit"
        value={slsdInStabilityPool.prettify(0)}
        unit={COIN}
        className="ml-10"
      />
      <SingleValue
        label="Your Deposit"
        value={stabilityDeposit.currentSLSD.prettify()}
        unit={COIN}
        className="ml-10"
      />
      <SingleValue
        label="APR"
        value={'N/A'}
        className="ml-10"
      />
      <Link to={`/stability-pools/${spAddress}`}>
        <Button className="ml-20">Manage</Button>
      </Link>
    </div>
  )
}